export const IFRAME_MESSAGES = {
  MODAL_OPENED: "modalOpened",
  MODAL_CLOSED: "modalClosed",
} as const;

export const postMessageToParent = (message: string): void => {
  if (window !== window.parent) {
    // Parent origin is unknown — the form can be embedded on any third-party domain
    window.parent.postMessage(message, "*"); // NOSONAR
  }
};
